import React from 'react'
import ArgosFooter from '@boltui/footer'

class Footer extends React.Component {
  constructor (props, context) {
    super(props, context)

    // this improves time to visually complete by stopping images and SVG assets
    // in the footer being requested until React initialised on the clientside
    this.state = {
      collapsedFooter: true
    }
  }

  componentDidMount () {
    this.setState({
      collapsedFooter: false
    })
  }

  render () {
    return this.state.collapsedFooter ? <ArgosFooter brandHidden serviceHidden socialappHidden /> : <ArgosFooter />
  }
}

export default Footer
